<template>
  <BaseModal ref="modal">
    <UiModalDialog class="jps-modal-input" :no-header="!_title"
      dialog-min-width="20rem"
    >
      <template #header>
        <BaseIcon size="size-6" v-if="_icon" :name="_icon" />
        {{ _titleVars ? lst(_title, _titleVars) : ls(_title) }}
      </template>
      <div class="jps-modal-content">
        <p v-if="_message">{{ _messageVars ? lst(_message, _messageVars) : ls(_message) }}</p>
      </div>
      <template #buttons>
        <button
          v-for="(o, i) in _options"
          :key="i"
          @click="select(o.option)"
          :class="o.class"
        >
          {{ ls(o.label) }}
        </button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import type { BaseModal } from '#components'
import type { SVG_NAMES } from '~/components/icons'

const { ls, lst } = useI18n()

const modal = ref<InstanceType<typeof BaseModal>>()
const _title: Ref<LangString> = ref()
const _titleVars: Ref<string[]> = ref()
const _message: Ref<LangString> = ref()
const _messageVars: Ref<string[]> = ref()
const _icon: Ref<SVG_NAMES> = ref()
const _options: Ref<OptionProps[]> = ref()
const openAwait = async (options?: Options) => {
  setOptionsValue(_title, 'title', props, options)
  setOptionsValue(_titleVars, 'titleVars', props, options)
  setOptionsValue(_message, 'message', props, options)
  setOptionsValue(_messageVars, 'messageVars', props, options)
  setOptionsValue(_icon, 'icon', props, options)
  setOptionsValue(_options, 'options', props, options)
  return await modal.value.openAwait<any>()
}
defineExpose({ openAwait })

interface Options {
  title?: LangString
  titleVars?: string[]
  message?: LangString
  messageVars?: string[]
  icon?: SVG_NAMES
  options: OptionProps[]
}

export interface OptionProps {
  label: LangString
  option?: any
  class?: string
}

interface Props {
  title?: LangString
  titleVars?: string[]
  message?: LangString
  messageVars?: string[]
  icon?: SVG_NAMES
  options?: OptionProps[]
}
const props = withDefaults(defineProps<Props>(), {})

const select = (n: any) => {
  if (n == null) {
    modal.value.reject()
  } else {
    modal.value.resolve(n)
  }
}
</script>

<style lang="scss" scoped>
.jps {
  .jps-modal-input {
    .jps-modal-content {
      padding-top: 0;
    }
    input,
    textarea {
      width: 100%;
    }
  }
}
</style>
